module.exports = __webpack_public_path__ + "img/hr-destroyer-robot-shadow.fff09ecf.png";